import React, { useState, useEffect } from 'react';
import { Card, CardBody, Container, Row, Col, CardText, Spinner } from 'reactstrap'; // <-- added Spinner
import api from '../services/api';
import moment from 'moment';

const ServicePicker = ({ selectedDate, selectedTime, event, onServiceSelected, resourceType }) => {
  const [selectedService, setSelectedService] = useState({ id: 0, title: 'Unknown', duration: 60 });
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true); // <-- new loading state

  useEffect(() => {
    const time = selectedTime
      ? moment(selectedTime).toISOString(true)
      : moment(selectedDate).startOf('day').toISOString(true);
    const resourceTypeParam = resourceType ? `&resource_type=${resourceType}` : '';

    setLoading(true); // start loading
    api.get(`/available-services/?slot=${time}&event=${event}${resourceTypeParam}`)
      .then(res => {
        const sortedServices = res.data.sort((a, b) => a.sortorder - b.sortorder);
        const customService = { id: 999, title: 'Custom', sortorder: Infinity, resource_type: resourceType };
        const updatedServices = [...sortedServices, customService];

        setServices(updatedServices);
      })
      .catch(err => console.log(err))
      .finally(() => setLoading(false)); // stop loading
  }, [selectedDate, selectedTime, event, resourceType]);

  const handleCardClick = (service) => {
    setSelectedService(service);
    onServiceSelected(service);
  };

  return (
    <Container>
      <Row>
        {loading ? (
          <Col className="text-center mt-3">
            <Spinner color="primary" />
            <p>Loading available services...</p>
          </Col>
        ) : services.length > 0 ? (
          services.map((service) => (
            <Col xs="12" key={service.id} className="mb-3">
              <Card
                onClick={() => handleCardClick(service)}
                className={service.class}
                style={{
                  cursor: 'pointer',
                  border: service.id === selectedService.id ? '2px solid' : '1px solid #ddd',
                }}
              >
                <Row>
                  <Col md="3">
                    <div
                      className={`rounded bg-${service.color_code || 'bg-secondary'}`}
                      style={{
                        height: 60,
                        width: 60,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        fontSize: '24px',
                        backgroundColor: service.color_code || '#ccc',
                      }}
                    />
                  </Col>
                  <Col md="9">
                    <CardBody>
                      <CardText>{service.title}
                        {service.resource_count > 1 ? (<span className='ms-2'><strong>({service.resource_count} resources needed)</strong></span>) : ''}
                      </CardText>
                    </CardBody>
                  </Col>
                </Row>
              </Card>
            </Col>
          ))
        ) : (
          <Col className="text-center mt-3">
            <p>No services available for this time.</p>
          </Col>
        )}
      </Row>
    </Container>
  );
};

export default ServicePicker;
